import { timeToInt } from '../../lib/dates';

export default function timeplanUnitShouldBeExpanded(timeplanUnit) {
  try {
    return timeToInt(timeplanUnit.to) < timeToInt(timeplanUnit.from);
  } catch (error) {
    return false;
  }
}
